module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('title', [_vm._v("Open Doors")]), _c('link', {
    attrs: {
      "href": "page-template.xpgt",
      "rel": "stylesheet",
      "type": "application/vnd.adobe-page-template+xml"
    }
  }), _vm._v(" "), _c('link', {
    attrs: {
      "href": "pdlmsr.css",
      "rel": "stylesheet",
      "type": "text/css"
    }
  }), _vm._v(" "), _c('meta', {
    attrs: {
      "content": "text/html; charset=UTF-8"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "chapter",
    attrs: {
      "id": "ch02"
    }
  }, [_c('div', {
    staticClass: "chapterHead"
  }, [_c('h2', {
    staticClass: "chapterNumber"
  }, [_c('span', {
    staticClass: "bold"
  }, [_c('span', [_vm._v("two")])])])]), _c('div', {
    staticClass: "chapterBody"
  }, [_c('p', {
    staticClass: "chapterOpenerText"
  }, [_c('span', [_c('span', {
    staticClass: "chapterOpenerFirstLetters"
  }, [_c('span', [_c('span', {
    staticClass: "bold"
  }, [_c('span', [_vm._v("P")])])])]), _vm._v("eter, having caught the red-eye from L.A, was at the door with his family at daybreak the next morning. It startled Elaine, bleary-eyed after the long night at the hospital and the few hours of restless sleep at home, that Peter’s wife Lauren and his small son and daughter, Renée and Eric, accompanied him. Their presence alarmed and disconcerted her. But, of course, Lisa had described Neil’s prognosis with no holds barred. She kissed her blond daughter-in-law’s cool cheek and embraced her exhausted grandchildren. She noted that Eric closely resembled Neil; her husband’s bright blue eyes stared up at her from the child’s face.")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("An hour later Denis and his partner Andrew arrived. Tall Denis, lean as always, newly returned from a visit to Andrew’s family in Jamaica where the island sun had burnished his very smooth skin and lightened the tangled curls of his chestnut-brown hair, held Elaine in brief embrace. Andrew held out his hand, fumbled for the appropriate words.")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("“I am so sorry,” he said. “This must be so hard for you.”")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("His words, delivered in the lilting accent of his island, were, after all, ill chosen. Elaine withdrew her hand.")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("“Actually, it’s Neil we worry about,” she replied and immediately regretted her tone. Andrew, she knew, was uneasy enough with their family, conscious of being a “person of color,” as he was described in the short bios offered in the high-end glossy journals that carried his photographs, conscious of being a non-Jew in the heart of a Jewish family, even a family as casual about their Jewishness as the Gordons.")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("Andrew, for all his talent and grace, would not have been their choice as Denis’s lifelong partner, Elaine and Neil had sadly acknowledged, just as it would not have been their choice for Denis to be gay. It pleased them, they assured each other, that Denis was happy with Andrew, and it was incumbent upon them to accept their relationship. And they had, welcoming Denis and Andrew into their home, traveling out to Santa Fe to visit them, always remembering Andrew’s birthday as they remembered Lauren’s and Moshe’s. Their in-law children were swept into the circle of caring and concern, albeit long-distance caring and concern. Denis lived his own life, made his own choices. All that concerned them was his happiness. Their children had full sovereignty over their lives. This they repeated again and again, to others and to themselves. That repetition assuaged the lingering sadness that overtook them in the darkness of the night or, inexplicably, when they stood at their window and stared out at a pale and melancholy wintry sunset.")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("Their friends admired their attitude, but then Elaine and Neil had long been much admired. It was agreed by friends and acquaintances alike that they had it all. They were successful in their careers, sealed in the cocoon of their insular togetherness, an inseparable, enmeshed couple content with each other and the life they had built so carefully.")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("“It was good of you to come, Andrew,” Elaine added, quick to apologize. She pressed her hand to his cheek, glad to feel the smoothness of his skin against her palm. The night had been long and lonely. She was unused to sleeping without the tenderness of touch.")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("“Of course I came. How could I not be with Denis at a time like this?”")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("She averted her eyes. She did not want to think of what he meant by “a time like this.”")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("Lisa flew down the stairs just then and hugged her brothers, smiled at Lauren whom she did not like, held her hand out to Andrew whom she did like and kissed her niece and nephew.")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("“I have to run. I’m going out to Kennedy to pick up Sarah and Moshe. They caught the last flight out of Ben Gurion last night,” she said, pulling on her driving gloves.")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("“They were able to make arrangements for all those children so quickly?” Lauren asked in surprise. “It would take me hours to get people to do that for Renée and Eric and I’d probably have to beg my friends or pay someone the earth. I can’t imagine getting coverage for four children just like that.”")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("“In that community, it’s apparently the norm for people to take care of each other,” Lisa said coolly. She herself might criticize her twin’s community and lifestyle but she resented the disparaging disbelief in Lauren’s voice. “The last time I was at Sandy’s—Sarah’s, I mean—she had three other children staying with her because their mother was sick. And according to her it was no big deal. Anyway, I’m off. We’ll see you at the hospital, Mom.” She draped an arm briefly and protectively around Elaine’s shoulder, kissed her on the cheek, made the requisite funny face at her niece and nephew and dashed out.")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("Minutes later, Elaine and her sons left for the hospital, Andrew staying behind to help Lauren with the children who had reached the whining stage of fatigue.")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("Neil was asleep when they entered his hospital room. The shades had been drawn against the sunlight and in the dimness his face was chalk white but his breathing was even, almost rhythmic. Two transparent IV lines dripped clear solutions into his motionless arms. A thin catheter dangled, discreetly concealed by a sheet. She dropped a kiss on his forehead and he seemed to smile but he did not open his eyes.")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("“Dad.” Peter’s voice quivered.")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("“He doesn’t hear you, Peter,” Elaine said gently. “He’s on a morphine drip which induces a very deep sleep.”")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("That much had been explained to her before she left the hospital the previous evening.")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("“Just routine,” Jack Newnham had said and Elaine had decided that Jack was overly fond of the word "), _c('em', {
    staticClass: "italic"
  }, [_c('span', [_vm._v("routine.")])])])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("Denis took his father’s hand, stroked his fingers one by one. His eyes grew moist; tears glistened on his sun-bronzed cheeks and Elaine fumbled for a tissue and wiped them away as though he were still a small boy rather than the tall lean man whose deep voice resonated through courtrooms.")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("“He looks so frail,” Denis said in bewilderment.")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("He and Peter looked at each other, their expressions stricken as though betrayed. Their father, that strong wise man who had never been ill, had never complained of even the most minor discomfort, ignoring the slight arthritis of his knee, the very occasional shortness of breath, their father who had raced with them into the surf on seaside vacations and who played tennis still with astounding grace and vigor, was not supposed to look so weak, so pale, so powerless. He was not supposed to die.")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("“But he’ll wake up?” Peter asked. He needed his father to awaken. He needed to hear his calm voice, to see the twinkle of wisdom in the bright blue of his eyes. There were questions he had to ask him, advice that only his father could give. He had thought to phone him for weeks now, to ask those questions, to seek that advice, but the rush of his days, the damn time difference between the two coasts had prevented that. And now this. He buried his head in his hands. Unlike Denis, tears did not come easily to him.")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("“He’ll wake up,” Elaine replied, speaking with an assurance she did not really feel.")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("Denis and Peter sat on either side of their father’s bed, Peter, always ready to spring into action sitting erect, Denis’s head lowered to the white coverlet. As though sensing his son’s presence, Neil’s hand rested briefly on Denis’s head. Denis had always been his favorite, Elaine knew. He was their last-born, a sensitive child, graceful and athletic with Neil’s own gift for solitude and analytic thinking. He was a thoughtful and persuasive arguer and it had not surprised them that he decided on law even after flirting briefly with psychology. Elaine remembered still, Neil’s words when Denis had disclosed his homosexuality to them.")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("“Are you sad?” she had asked her husband, her own heart torn with a grief she would not express. She had turned away so that he would not read the sorrow in her eyes and clasped her hands so that he would not see how her fingers trembled.")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("“I’m sad that we won’t see another small Denis,” he had said and he had wept then as his son wept now.")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("Elaine sighed and went to the window. She lifted the shade and allowed the deceptive harsh sunlight of late autumn to flood the room. Peering down, she saw Jack Newnham’s car pull into the parking lot reserved for physicians, taking a spot next to her own car—that was a privilege soon to be surrendered she thought wryly. Doctors’ widows could not expect a parking spot. "), _c('em', {
    staticClass: "italic"
  }, [_c('span', [_vm._v("“Widow,”")])]), _vm._v(" she whispered, rolling the word back and forth across her tongue as though tasting it. She saw Jack stop and speak to another doctor—Harv Bernstein, the neurologist who had examined Neil the previous day, who had spoken to her softly, sympathetically but had not met her eyes.")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("“I wish there was more we could do,” he had said.")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_c('em', {
    staticClass: "italic"
  }, [_c('span', [_vm._v("More? You haven’t done a damn thing!")])]), _vm._v(" She had wanted to scream but she had remained silent, the quiescent wife who now depended on the kindness of doctors and nurses, technicians and aides, the ministrations of strangers.")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("She pulled a chair up next to Peter, caressed his hand, as though she could somehow pat away his sorrow, and glanced at her watch. It took a quarter of an hour for Jack and Harv Bernstein to tap tentatively on the door and to enter the room, diffident visitors despite the authority vested in them. They shook hands with Denis and with Peter. Harv touched her shoulder, Jack, more daringly, kissed her on the cheek. They both studied Neil’s chart.")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("“No change,” Harv said. “Which is all we can hope for at this point. He’s resting comfortably.”")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("“How do you know?” she asked harshly and immediately regretted her words.")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("Jack looked stricken, Harv uncomfortable and Peter turned away in embarrassment. Denis, the skilled mediator, intervened in the conciliating tone cultivated for dealing with recalcitrant clients.")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("“We know you’re doing everything possible,” he said. “And we want to thank you. I wonder if you can give us some idea of what to expect.”")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("The two doctors looked at each other.")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("“Perhaps we could have this discussion when your sisters get here,” Jack Newnham said hesitantly. “Lisa has a very clear understanding of your father’s condition. A great deal of her radiology work, in fact, is now focused on the brain. She had an excellent paper published in a journal not long ago which dealt with aneurysms.”")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("“I didn’t know that,” Elaine said fretfully.")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("She should have known, she supposed, but her children’s professional lives, their accomplishments, had for a long time been shadowy terrain. She and Neil had their own work, their own shared good life. They were not parents who lived vicariously through their children and preened themselves on their successes. They loved their sons and daughters, they were proud of them, and that had always seemed to suffice. Her eyes flitted from Peter to Denis and Denis took her hand in his own and held it tightly.")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("“Neil knew it. He sent me an offprint,” Harv said. “You can be sure that he would rely on Lisa’s judgment.”")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("“I am sure of that,” Elaine said. “And I want to thank you. I’m just sort of strung out.”")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("“Of course you are.” Harv’s voice softened and Elaine felt more kindly toward him, remembering his difficulties with his own daughter, knowing that he would never be able to rely on her judgment.")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("The two doctors, Neil’s friends, Neil’s colleagues, left then, again carefully shaking hands with Peter and Denis and smiling sadly, apologetically at Elaine.")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("A parade of nurses and technicians followed, competent caregivers who nodded at them in sympathy and did their work swiftly and skillfully. The IV drips were monitored and changed, the catheter dealt with, Neil’s pulse taken, a droplet of blood drawn from his finger. Peter went down to the cafeteria and returned with coffee which they drank and bagels which they did not eat. They heard the click of high heels on the polished floor, the sound of voices so similar in range and cadence that they could not be distinguished one from the other.")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("Sarah and Lisa entered the room, talking quietly. The twin sisters did not look alike but they shared the same musical voice, spoke in the same light tone. That identical rise and fall, that sameness of inflection, had once caused their brothers to tease them and now it caused them to smile.")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("They embraced, the brothers taking in Sarah’s full figure, her face sorrowful yet strangely serene, her marriage wig fashioned into the smooth ponytail they remembered from her high school and college days, her years as a cheerleader when the ponytail had bobbed up and down, when it had tumbled out of her cap after a varsity swim meet. But this ponytail was stiff, restrained by a tortoise-shell clip that would never be removed from the synthetic locks. Sarah, who as a girl, then called Sandy, (the name Sarah had been used only at her baby naming and at her bat mitzvah) had favored miniskirts, brightly colored body-hugging tops, backless loafers in wild jungle colors, now wore a long denim skirt, a heavy, loose white sweater that concealed the curves of her body, the rise of her breasts, sneakers and white socks. But she was beautiful still and her presence brought a new peace into the room.")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("“How is he?” she asked and approached her father’s bed.")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("“The same,” Elaine said wearily. “How was your flight?” She touched her daughter’s brow, a gesture borrowed from Neil who could discern fatigue, a raised temperature, the onset of flu, by a touch of his fingertips.")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("“Like all El Al flights, horrible,” Sarah said. “But we landed safely and I’m here, "), _c('em', {
    staticClass: "italic"
  }, [_c('span', [_vm._v("baruch HaShem.")])]), _vm._v(" Blessed be His name.”")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("Her eyes did not leave her father’s face and Elaine realized that it had been over a year since Sarah had seen him. She and Neil had talked about going to Jerusalem again, but something had always intervened. She had several commissions to complete—the new terra-cotta formula she was using had sparked a sudden popularity; Neil had been asked to contribute a chapter to an important new medical text. And of course there were their subscriptions—the opera, the symphony, an interesting series of plays at the Roundabout. And so they had put off the trip to Israel, just as they had put off the journeys west to visit Denis and Andrew, Peter and his family, reluctant to leave their work, to surrender their time together, the quiet of their home in the evening hours, the welcoming darkness of their bedroom. And now they would never make those journeys. She would be a solitary traveler, a solitary visitor. Regret tightened about her heart like a vise.")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("Sarah kissed her father’s cheek. Her lips moved in prayer. Neil’s eyes opened. He smiled at her.")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("“All this way? You came all this way?” There was wonderment in his voice. He looked at his children who moved closer to him, at Elaine, who fingered that lick of silver hair, silken to her touch. “You’re all here? Peter, Denis, Lisa. All of you. Elaine, isn’t that wonderful?”")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("“Wonderful,” she agreed. She marveled that she could bring forth voice. “Of course we’re all here. We love you, Neil.”")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("She spoke for all of them because her sons, even Peter, were openly weeping now and Lisa clutched Sarah’s hand, her face contorted. But Sarah’s expression did not change. Her lips moved in prayer, the softly spoken Hebrew falling in wisps of sound through the silence of their sorrow.")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("“Neil, how do you feel?” Elaine asked.")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("“Tired. Very, very tired,” he replied.")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("His eyelids fluttered briefly and then closed. He lay very still.")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("Lisa lifted his wrist, placed her ear against his heart, lifted the phone and spoke softly into it. A nurse glided into the room and handed Lisa a mirror, a stethoscope. She listened to her father’s heart and shook her head. She held the mirror to her father’s mouth, his nose, and returned it to the nurse.")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("“He’s gone,” she said. “Daddy’s gone.” Her voice broke and she stepped into Peter’s outstretched arms.")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("“"), _c('em', {
    staticClass: "italic"
  }, [_c('span', [_vm._v("Baruch dayan emet,")])]), _vm._v(" blessed is the true judge,” Sarah said softly. She touched her father’s head. “"), _c('em', {
    staticClass: "italic"
  }, [_c('span', [_vm._v("Shma Yisrael,")])]), _vm._v(" hear Oh Israel, the Lord is our God, the Lord is one.” She intoned the prayer uttered before death which Neil might or might not have murmured had he been given the time.")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("Elaine knelt beside the bed. She kissed her husband’s lips and slid her hands, one last time, across the smooth familiar flesh of his body.")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_c('em', {
    staticClass: "italic"
  }, [_c('span', [_vm._v("“Zieskeit,”")])]), _vm._v(" she said. “Oh, my "), _c('em', {
    staticClass: "italic"
  }, [_c('span', [_vm._v("zieskeit.")])]), _vm._v("”")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("His eyes were open and she closed them; the lids were soft, soft and quiescent beneath her tender touch. She could not bear that softness. Her grief broke forth then, a cascade of sorrow. She trembled, her heart pounded, her face crumbled.")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("“Neil!” she screamed. “Neil!”")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("Her children surrounded her, encircled her and slowly, slowly, led her from the room.")])])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-7198cc5d","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/opendoors_ch02.vue
// module id = 75
// module chunks = 0